import get from 'lodash.get';
import { Commodity } from 'services/commodities/types';
import {
    VirtualizedTableItem,
    VirtualizedTableColumns
} from 'services/virtualizedTable/types';
import { FIELD_TYPE_STRING } from 'components/VirtualizedTable/constants';
import { makeSelectTableColumnWidths } from 'services/columnWidths/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

// @ts-ignore
import { selectCommoditiesArray } from 'services/commodities/selectors';
// @ts-ignore

export const selectCommoditiesTableColumns = createDeepEqualSelector(
    [makeSelectTableColumnWidths()],
    (tableColumnWidths) => {
        const result: VirtualizedTableColumns = [
            {
                label: 'Name',
                value: 'name',
                width: 250,
                type: FIELD_TYPE_STRING,
                validators: 'isRequired'
            }
        ];

        return result.map((column) => {
            const { width, value } = column;
            return {
                ...column,
                width: get(tableColumnWidths, value, width)
            };
        });
    }
);

export const selectCommoditiesItems = createDeepEqualSelector(
    selectCommoditiesArray,
    (commoditiesArray) =>
        commoditiesArray.map(
            (commodity: Commodity): VirtualizedTableItem => ({
                key: commodity.id,
                id: commodity.id,
                name: commodity.name
            })
        )
);
